var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWelcomePc1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2844_23644)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.6665,
    y: 2.6665,
    width: 26.6667,
    height: 26.6667,
    rx: 13.3333,
    fill: "#E1DEF8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2844_23644",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2844_23644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 22.6668C15.0779 22.6668 14.2113 22.4918 13.4002 22.1418C12.5891 21.7918 11.8835 21.3168 11.2835 20.7168C10.6835 20.1168 10.2085 19.4113 9.8585 18.6002C9.5085 17.7891 9.3335 16.9224 9.3335 16.0002C9.3335 15.0779 9.5085 14.2113 9.8585 13.4002C10.2085 12.5891 10.6835 11.8835 11.2835 11.2835C11.8835 10.6835 12.5891 10.2085 13.4002 9.8585C14.2113 9.5085 15.0779 9.3335 16.0002 9.3335C16.9224 9.3335 17.7891 9.5085 18.6002 9.8585C19.4113 10.2085 20.1168 10.6835 20.7168 11.2835C21.3168 11.8835 21.7918 12.5891 22.1418 13.4002C22.4918 14.2113 22.6668 15.0779 22.6668 16.0002C22.6668 16.9224 22.4918 17.7891 22.1418 18.6002C21.7918 19.4113 21.3168 20.1168 20.7168 20.7168C20.1168 21.3168 19.4113 21.7918 18.6002 22.1418C17.7891 22.4918 16.9224 22.6668 16.0002 22.6668ZM16.0002 21.3335C17.4891 21.3335 18.7502 20.8168 19.7835 19.7835C20.8168 18.7502 21.3335 17.4891 21.3335 16.0002C21.3335 15.9224 21.3307 15.8418 21.3252 15.7585C21.3196 15.6752 21.3168 15.6057 21.3168 15.5502C21.2613 15.8724 21.1113 16.1391 20.8668 16.3502C20.6224 16.5613 20.3335 16.6668 20.0002 16.6668H18.6668C18.3002 16.6668 17.9863 16.5363 17.7252 16.2752C17.4641 16.0141 17.3335 15.7002 17.3335 15.3335V14.6668H14.6668V13.3335C14.6668 12.9668 14.7974 12.6529 15.0585 12.3918C15.3196 12.1307 15.6335 12.0002 16.0002 12.0002H16.6668C16.6668 11.7446 16.7363 11.5196 16.8752 11.3252C17.0141 11.1307 17.1835 10.9724 17.3835 10.8502C17.1613 10.7946 16.9363 10.7502 16.7085 10.7168C16.4807 10.6835 16.2446 10.6668 16.0002 10.6668C14.5113 10.6668 13.2502 11.1835 12.2168 12.2168C11.1835 13.2502 10.6668 14.5113 10.6668 16.0002H14.0002C14.7335 16.0002 15.3613 16.2613 15.8835 16.7835C16.4057 17.3057 16.6668 17.9335 16.6668 18.6668V19.3335H14.6668V21.1668C14.8891 21.2224 15.1085 21.2641 15.3252 21.2918C15.5418 21.3196 15.7668 21.3335 16.0002 21.3335Z",
    fill: "#62648F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2844_23644"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.6665,
    y: 2.6665,
    width: 26.6667,
    height: 26.6667,
    rx: 13.3333,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomePc1);
export default __webpack_public_path__ + "static/media/welcome_pc_1.167f607f2631e1bf6f9edcf73becd54b.svg";
export { ForwardRef as ReactComponent };